import { useMemo } from "react";
import {
  addMonths,
  eachDayOfInterval,
  endOfMonth,
  startOfMonth,
  subMonths,
} from "date-fns";

export const useCalendarDays = () =>
  useMemo(() => {
    const now = startOfMonth(new Date());
    const start = startOfMonth(subMonths(now, 2)); // 2 months back
    const end = endOfMonth(addMonths(now, 4)); // 4 months forward
    return eachDayOfInterval({ start, end });
  }, []);
